import { fetchWithToken } from '@adsk/acs-sc-web-platform-api';
import { getApiBaseUrl } from '../config';
import { headers, HttpMethod } from '../constants';
import { CreateSDKConfig } from './types';
import { EntityStatus, NewRfiType, RfiType } from '../types';
import { GetRfiTypesQueryParams } from '../types/requests/getRfiTypesQueryParams';
import { GetRfiTypesResponse } from '../types/responses/getRfiTypes';
import { getFlatParams } from '../utils/fetchHelpers';

const END_POINT = 'rfi-types';

const RfiTypesApi = ({ projectId }: CreateSDKConfig) => {
  const url = `${getApiBaseUrl(projectId)}/${END_POINT}`;

  return {
    get(queryParams: GetRfiTypesQueryParams): Promise<GetRfiTypesResponse> {
      const {
        limit,
        offset,
        filterStatus = [EntityStatus.Active, EntityStatus.Inactive, EntityStatus.Hidden],
      } = queryParams;
      const searchParams = new URLSearchParams();
      if (limit) {
        searchParams.set('limit', limit.toString());
      }
      if (offset) {
        searchParams.set('offset', offset.toString());
      }
      if (filterStatus?.length) {
        searchParams.set('filter[status]', getFlatParams(filterStatus));
      }
      const search = searchParams.toString();

      return fetchWithToken(search ? `${url}?${search}` : url);
    },
    add(rfiType: NewRfiType): Promise<RfiType> {
      return fetchWithToken<RfiType>(url, {
        method: HttpMethod.Post,
        body: JSON.stringify(rfiType),
        headers,
      });
    },
    update(id: string, rfiType: Partial<NewRfiType>): Promise<RfiType> {
      const patchUrl = `${url}/${id}`;
      return fetchWithToken<RfiType>(patchUrl, {
        method: HttpMethod.Patch,
        body: JSON.stringify(rfiType),
        headers,
      });
    },
  };
};

export default RfiTypesApi;
